/**
 * exp/application-process-slider — process steps Swiper.
 */
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';

const roots = document.querySelectorAll('.exp-application-process-slider-block');

roots.forEach((root) => {
	const el = root.querySelector('.swiper-container-application-process-slider');

	if (!el) {
		return;
	}

	const prevEl = root.querySelector('.swiper-button-prev');
	const nextEl = root.querySelector('.swiper-button-next');

	// eslint-disable-next-line no-new
	new Swiper(el, {
		modules: [Navigation],
		slidesPerView: 1.1,
		spaceBetween: 24,
		watchOverflow: true,
		preventInteractionOnTransition: true,
		navigation: {
			prevEl: prevEl || null,
			nextEl: nextEl || null,
		},
		breakpoints: {
			768: {
				slidesPerView: 2.2,
				spaceBetween: 24,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 32,
			},
		},
	});
});
